export const AVERAGE_HOUSEHOLD_SIZE = 6;
export const PDR_TARGET_HH_REACHED = 28000;
export const PDR_TARGET_HH_ESTIMATED = 168000;
export const TARGET_OUTREACH_1 = 43000;
export const TARGET_OUTREACH_1b = 86000;

export const ACTIVITY_OVERLAPS = {
  fns: 100,
  wfasGrant: 40,
  cboAPG: 50,
  climateChange: 40,
  msme: 100,
  msp: 10,
  marketinfra: 60,
  csos: 30,
};